import { useKycVerification } from "providers/employee/KycVerificationProvider";
import { features, useFeature } from "providers/FeaturesProvider";
import { Outlet, useLocation } from "react-router-dom";

const EXCLUDED_ROUTES = [
  "/kyc-request",
  "/post-termination",
  "/onboarding",
  "/sign-",
  "/disclaimers",
] as const;

/**
 * Layout for employment routes (dashboard, withdrawals, etc.).
 *
 * When the Tasks feature is enabled, we rely on the dashboard/task-based
 * experience and do not show the legacy KYC banner.
 *
 * When the Tasks feature is disabled, we revert to the previous behaviour
 * and show the legacy `KycBanner` (except for excluded routes).
 */
export const UnifiedVerificationLayout = () => {
  const location = useLocation();
  const { KycBanner } = useKycVerification();
  const isTasksFeatureEnabled = useFeature(features.TASKS_FEATURE);

  const showKycBanner =
    !isTasksFeatureEnabled &&
    !EXCLUDED_ROUTES.some((route) => location.pathname.includes(route));

  return (
    <>
      {showKycBanner && <KycBanner />}
      <Outlet />
    </>
  );
};

export default UnifiedVerificationLayout;
